// extracted by mini-css-extract-plugin
module.exports = {"action":"actionsColumn_action__3kvXW","fetching":"actionsColumn_fetching__3QTyB"};